<template>
    <card borderColor="gray-40">
        <div class="flex-row ai-center">
            <SaasIcon v-if="provider === 'gmail'" width="32" height="26" icon="svgGmail" />
            <SaasIcon v-if="isGoogleProvider" width="32" height="26" icon="svgGoogle" />
            <SaasIcon v-if="isMicrosoftProvider" width="32" height="26" icon="svgOffice365" />
            <span class="ml-2 semibold">{{ user }}</span>
            <CompassLink
                :label="ctaLabel"
                type="primary"
                class="flex-item-right"
                @click="$emit('callback')"
            />
        </div>
    </card>
</template>

<script>
import Card from 'vcomponents/Card.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        Card,
    },
    props: {
        provider: {
            type: String,
            required: true,
        },
        user: {
            type: String,
            required: true,
        },
        ctaLabel: {
            type: String,
            required: false,
            default: window.i18n.__('Valider'),
        },
    },
    computed: {
        isMicrosoftProvider() {
            return ['office365', 'outlook'].includes(this.provider);
        },
        isGoogleProvider() {
            return this.provider === 'google';
        },
    },
};
</script>

<style lang="scss">
.icon-provider {
    path {
        cursor: default;
    }
}
</style>
